import QuestionTitle from '@/ui/components/inspectionReport/items/QuestionTitle.vue';
import { h, defineComponent } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { ImageAsset } from '@/ui/components/asset/ImageAsset';
import { ImageAssetPdf } from '@/ui/components/asset/ImageAssetPdf';
import TableBox from '@/ui/components/inspectionReport/items/table/TableBox.vue';
import { DocumentAsset } from '@/ui/components/asset/DocumentAsset';

export const Instruction = defineComponent<ItemProps>({
  name: 'Instruction',
  props: ['item'],
  setup(props) {
    const getAssetComponent = (imageId: string | null | undefined) => imageId ? ImageAsset : ImageAssetPdf;

    return function render() {
      let imageInQueryElement = null;
      let childElement = null;

      if (props.item.image_id || props.item.image) {
        imageInQueryElement = h(getAssetComponent(props.item.image_id), {
          class: 'mb-2 inspection-report__question-img',
          props: { photo: props.item },
        });
      }

      if (props.item.params.image_id || props.item.params.image) {
        childElement = h(getAssetComponent(props.item.params.image_id), {
          class: 'mr-3 inline-block inspection-report__image-drawing-thumbnail',
          props: { photo: props.item.params },
        });
      }

      return h('table', {
        class: 'inspection-report__table',
      }, [
        h('tr', [
          h(TableBox, [
            imageInQueryElement,
            h('span', { class: 'font-semibold' }, [
              h(QuestionTitle, { props: { question: props.item } }),
              h(DocumentAsset, { props: { item: props.item } }),
            ]),
          ]),
        ]),
        childElement
        && h('tr', [h(TableBox, [childElement])]),
      ]);
    };
  },
});
